import { CommissionSyntheseEdition } from './commission-synthese-edition.model';
import { CommissionEchantillonEdition } from './commission-echantillon-edition.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class CommissionCahierEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        libelle: { key: 'libelle', optional: true, default: '' },
        synthese: { key: 'synthese', converter: new (ClassConverterFactory.build(CommissionSyntheseEdition))(), optional: true },
        echantillons: {
            key: 'echantillons',
            converter: new (ArrayClassConverterFactory.build(CommissionEchantillonEdition))(),
            optional: true,
            default: () => []
        }
    };

    id: number;
    libelle: string;
    synthese: CommissionSyntheseEdition;
    echantillons: CommissionEchantillonEdition[];
}
